/**
 * Услуги, которые могут быть доступны для подключения
 */
export const SERVICES_HOME = {
  TV: {
    name: "TV",
    title: "Кабельное ТВ",
    icon: "tv",
  },
  IPTV: {
    name: "IPTV",
    title: "Уфанет ТВ",
    icon: "ufanetTv",
  },
  INTERNET: {
    name: "INTERNET",
    title: "Интернет",
    icon: "internet",
  },
  INTERNET_TV: {
    name: "INTERNET_TV",
    title: "Интернет и Кабельное ТВ",
    icon: "package",
  },
  INTERNET_IPTV: {
    name: "INTERNET_IPTV",
    title: "Интернет и Уфанет ТВ",
    icon: "package",
  },
};

/**
 * Услуги доступные для ЮЛ. Перечень в ui всегда статичный
 */
export const SERVICES_BUSINESS = {
  INTERNET: {
    id: 1,
    name: "INTERNET",
    title: "Интернет",
    desc: "Надежный, скоростной, безлимитный интернет под любые задачи",
    icon: "internet",
  },
  VIDEO: {
    id: 31,
    name: "VIDEO",
    title: "Видеонаблюдение",
    desc: "Просмотр со смартфона или компьютера и облачный архив записей",
    icon: "cam",
  },
  PHONE: {
    id: 103,
    name: "PHONE",
    title: "Телефония",
    desc: "Приятные цены и бесплатные звонки внутри сети",
    icon: "phoneAnalog",
  },
  TV: {
    id: 104,
    name: "TV",
    title: "Телевидение",
    desc: "Более 220 цифровых каналов, более 35 HD-каналов",
    icon: "tv",
  },
  MY_TV: {
    id: 80,
    name: "MY_TV",
    title: "MуTv",
    desc: "Создай собственный телеканал. Продавай услуги. Транслируй атмосферу!",
    icon: "myTv",
  },
  ROBOTEL: {
    id: 101,
    name: "ROBOTEL",
    title: "Роботел",
    desc: "Колл-центр с голосовым помощником",
    icon: "robotel",
  },
  WIFI: {
    id: 102,
    name: "WI_FI",
    title: "Wi-Fi для бизнеса",
    desc: "Используйте новые возможности для вашего бизнеса",
    icon: "wifi",
  },
};
